<script setup>
defineProps({
  width: {
    type: Number,
    default: 12,
  },
  height: {
    type: Number,
    default: 12,
  },
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="IconFeedback" clip-path="url(#clip0_3358_18204)">
      <g id="Vector">
        <path
          d="M7.96516 0.5H7.20269C7.00853 0.5 6.85113 0.655698 6.85113 0.847748V1.40897L2.46922 2.97562H1.28173C0.574994 2.97562 0 3.54435 0 4.24343V5.82576C0 6.32436 0.292595 6.75647 0.716768 6.96342V10.4103C0.716768 11.0111 1.211 11.5 1.81847 11.5C2.42595 11.5 2.92016 11.0111 2.92016 10.4103V7.23052L6.85113 8.6589V9.22149C6.85113 9.41354 7.00853 9.56924 7.20269 9.56924H7.96516C8.56263 9.56924 9.0487 9.08844 9.0487 8.49745V1.57176C9.0487 0.980796 8.56263 0.5 7.96516 0.5ZM0.703127 4.24343C0.703127 3.92786 0.962698 3.67109 1.28173 3.67109H2.21703V6.39808H1.28173C0.962674 6.3981 0.703127 6.14135 0.703127 5.82576V4.24343ZM1.81847 10.8045C1.5987 10.8045 1.41989 10.6276 1.41989 10.4103V7.0936H2.21703V10.4103C2.21703 10.6276 2.03825 10.8045 1.81847 10.8045ZM2.92016 6.48958V3.55392L6.85113 2.14846V7.91797L2.92016 6.48958ZM8.3456 8.49745C8.3456 8.70494 8.17495 8.87374 7.96519 8.87374H7.55428V1.1955H7.96519C8.17495 1.1955 8.3456 1.36429 8.3456 1.57176V8.49745Z"
          fill="#1F1F1F"
        />
        <path
          d="M10.4822 5.37609H11.6484C11.8426 5.37609 12 5.22039 12 5.02834C12 4.83629 11.8426 4.68059 11.6484 4.68059H10.4822C10.288 4.68059 10.1306 4.83629 10.1306 5.02834C10.1306 5.22039 10.288 5.37609 10.4822 5.37609Z"
          fill="#1F1F1F"
        />
        <path
          d="M11.7978 7.28306L10.6315 6.74117C10.4558 6.65959 10.2464 6.73424 10.1638 6.90807C10.0813 7.08192 10.1568 7.28904 10.3326 7.37069L11.4988 7.91257C11.5471 7.93501 11.5979 7.94565 11.648 7.94565C11.7801 7.94565 11.9066 7.87172 11.9665 7.74568C12.049 7.57183 11.9735 7.36471 11.7978 7.28306Z"
          fill="#1F1F1F"
        />
        <path
          d="M10.4823 3.34859C10.5324 3.34859 10.5832 3.33795 10.6315 3.3155L11.7978 2.77362C11.9735 2.69197 12.049 2.48485 11.9665 2.311C11.8839 2.13715 11.6745 2.06248 11.4988 2.1441L10.3326 2.68599C10.1568 2.76764 10.0813 2.97476 10.1638 3.14861C10.2237 3.27463 10.3502 3.34859 10.4823 3.34859Z"
          fill="#1F1F1F"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3358_18204">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
